module.exports = __webpack_public_path__ + "img/png.d663d485.svg";